'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.577 19.005v1.329h1.995v-1.329h.666v1.662a.333.333 0 0 1-.333.333h-2.66a.333.333 0 0 1-.334-.333v-1.662h.666Zm7.965-12.752v11.753a.333.333 0 0 1-.333.333H6.456v-.666h11.42V6.253h.666Zm-7.668 7.667v1.995H8.661v-.666h1.547V13.92h.666ZM16.694 3v.666H5.274v11.42h-.666V3.333c0-.184.15-.333.333-.333h11.753Zm-.965 5.604c0 1.188-.383 2.116-1.14 2.758-.646.547-1.529.861-2.625.931l-.043-.665c.95-.06 1.703-.32 2.237-.774.61-.516.906-1.252.906-2.25h.665ZM11.63 5.108c1.39 0 2.23.224 2.893.774l-.424.513c-.54-.447-1.233-.62-2.469-.62H8.724v5.861h-.666V5.108h3.572Zm-.11 1.762c.676 0 1.17.145 1.512.443l-.438.502c-.212-.185-.574-.279-1.075-.279h-.645v2.126h-.666V6.87h1.311Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18.118 3h1.81c.198 0 .296.239.157.378L5.189 18.274a.22.22 0 0 1-.157.065h-1.81a.222.222 0 0 1-.157-.378L17.96 3.065A.22.22 0 0 1 18.118 3",
    fill: "currentColor"
  })));
});
var FwSet0ParkingNo = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0ParkingNo = FwSet0ParkingNo;